import { createFileRoute } from "@tanstack/react-router";
import { ExperienceDeepLink } from "@/components/ExperienceDeepLink";

export const Route = createFileRoute("/e/$slug")({
  head: ({ params }) => {
    const title = `Backland — ${params.slug}`;
    return {
      meta: [
        { title },
        { property: "og:title", content: title },
      ],
    };
  },
  component: ExperienceDeepLinkRoute,
});

function ExperienceDeepLinkRoute() {
  const { slug } = Route.useParams();
  return <ExperienceDeepLink slug={slug} />;
}
